import type { Recurrence } from "@recurrences/recurrencesClient";
import cronstrue from "cronstrue";

/**
 * A human-readable cadence for a recurrence — either its fixed interval
 * ("Every 30 min", "Hourly", "Daily") or a humanized cron expression. Falls back
 * to "—" when neither is set.
 */
/** Humanize a cron string for inline help, or null when it's invalid. */
export const describeCron = (cron: string): string | null => {
  try {
    return cronstrue.toString(cron, { verbose: true });
  } catch {
    return null;
  }
};

export const cadenceLabel = (recurrence: Recurrence): string => {
  if (recurrence.cron) {
    try {
      return cronstrue.toString(recurrence.cron, { verbose: true });
    } catch {
      return recurrence.cron;
    }
  }

  const minutes = recurrence.intervalMinutes;
  if (!minutes) return "—";
  if (minutes === 60) return "Hourly";
  if (minutes === 1440) return "Daily";
  if (minutes % 1440 === 0) return `Every ${minutes / 1440} days`;
  if (minutes % 60 === 0) return `Every ${minutes / 60} hr`;
  return `Every ${minutes} min`;
};
